import React, { useState } from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { MuiPickersUtilsProvider, TimePicker, DatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { dateLocale } from "@icarius-localization/strings";
import { useSelector } from "react-redux";
import { getSessionTypes } from "@icarius-pages/myTraining/selectors";
import { createDateFromDDMMYYYY, createDateFromHHMM, formatDateHHMM, formatDateYYYYMMDD } from "@icarius-utils/date";

const gridStyle = { padding: 10 };

const UpdateSessionAttemptDialog = (props) => {

  const {
    open,
    data,
    isSession,
    handleSubmit,
    handleClose,
  } = props;

  const [type, setType] = useState(data?.type || "");
  const [date, setDate] = useState(data?.date ? createDateFromDDMMYYYY(data.date) : null);
  const [time, setTime] = useState(data?.time ? createDateFromHHMM(data.time) : null);
  const [location, setLocation] = useState(data?.location);
  const [additionalInfo, setAdditionalInfo] = useState(data?.additionalInfo);

  const sessionTypes = useSelector(getSessionTypes);

  const submit = () => {
    handleSubmit({
      type,
      location,
      additionalInfo,
      date: date ? formatDateYYYYMMDD(date) : null,
      time: time ? formatDateHHMM(time) : null,
    });
    handleClose();
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"sm"}
      fullWidth={true}
    >
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {getLocalizedString(isSession ? "updateSession" : "updateAttempt")}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <DialogContent style={{ paddingTop: 0 }}>
          <Grid container item alignItems="flex-start" xs={12}>
            {
              isSession &&
              <Grid container item alignItems="center" xs={12} style={gridStyle}>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel required id={`label-type`}>{getLocalizedString("sessionType")}</InputLabel>
                  <Select
                    value={type}
                    labelId={`label-type`}
                    id={`select-type`}
                    onChange={(e) => setType(e.target.value)}
                    margin={"none"}
                  >
                    {
                      sessionTypes?.map((item) => (
                        <MenuItem
                          className={"whiteText"}
                          key={item.key}
                          value={item.key}
                        >
                          {item.value}
                        </MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              </Grid>
            }
            <Grid container item alignItems="center" xs={6} style={gridStyle}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={dateLocale}>
                <DatePicker
                  fullWidth
                  label={getLocalizedString("dateFrom")}
                  clearLabel={getLocalizedString("clear")}
                  okLabel={getLocalizedString("ok")}
                  invalidDateMessage=''
                  format="dd/MM/yyyy"
                  margin={'none'}
                  value={date || null}
                  onChange={(e) => setDate(e)}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid container item alignItems="center" xs={6} style={gridStyle}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={dateLocale}>
                <TimePicker
                  fullWidth
                  ampm={false}
                  label={getLocalizedString("time")}
                  value={time || null}
                  onChange={(e) => setTime(e)}
                  cancelLabel={getLocalizedString("cancel")}
                  invalidDateMessage=""
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid container item alignItems="center" xs={12} style={gridStyle}>
              <TextField
                fullWidth
                margin={"none"}
                label={getLocalizedString("location")}
                value={location || ""}
                onChange={(e) => setLocation(e.target.value.substring(0, 254))}
                helperText={getLocalizedString("enterLinkOrAddress")}
              />
            </Grid>
            {
              isSession &&
              <Grid container item alignItems="center" xs={12} style={gridStyle}>
                <TextField
                  fullWidth
                  margin={"none"}
                  label={getLocalizedString("additionalInfo")}
                  value={additionalInfo || ""}
                  onChange={(e) => setAdditionalInfo(e.target.value.substring(0, 254))}
                />
              </Grid>
            }
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
          <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("accept")} />
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default UpdateSessionAttemptDialog;